<template>
    <div>
        <Title title="联系我们" path="/my"/>

        <div class="abbox">
            <div class="abnav">
                <router-link to="/about">关于我们</router-link>
                <router-link to="/mianze">免责声明</router-link>
                <router-link to="/treaty">用户协议</router-link>
                <router-link to="/contact" class="curr">联系我们</router-link>
            </div>
            <div class="abright">
                <div class="abmain">
<!--                    <div class="title"><span>联系我们</span><em>/Contact US</em><i></i></div>-->
                    <div class="con abcontact">
                        <div class="item">
                            <div class="icon icon1"></div>
                            <div class="itcc">
                                <div class="nm">客服热线</div>
                                <div class="tel">{{tel}}</div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="icon icon2"></div>
                            <div class="itcc chat">
                                <div class="nm">客服微信</div>
                                <div class="img"><img src="../../assets/images/chat.jpg"/></div>
                            </div>
                        </div>
                    </div>
                    <div class="title"><span>工作时间</span><em>/Working hours</em><i></i></div>
                    <div class="con abcontact">
                        <div class="tm">
                            <p><span>微信客服</span>（周一至周日 09:00-24:00）</p>
                            <p><span>电话客服</span>（周一至周五 09:00-22:00，周六日 09:00-24:00）</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Title from '../public/title'
    export default {
        name: "about",
        components: {
          Title
        },
        data() {
            return {
                'tel': this.$getContactTel(),
            }
        },
        activated() {
            this.$backTop()
        },
        methods: {

        },
    }
</script>

<style scoped>
</style>
